import { render, staticRenderFns } from "./NoCard.vue?vue&type=template&id=b20aaa20&scoped=true&"
import script from "./NoCard.vue?vue&type=script&lang=js&"
export * from "./NoCard.vue?vue&type=script&lang=js&"
import style0 from "./NoCard.vue?vue&type=style&index=0&id=b20aaa20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20aaa20",
  null
  
)

export default component.exports